import { render } from "./CarouselD.vue?vue&type=template&id=47970aee&scoped=true"
import script from "./CarouselD.vue?vue&type=script&lang=js"
export * from "./CarouselD.vue?vue&type=script&lang=js"

import "./CarouselD.vue?vue&type=style&index=0&id=47970aee&lang=scss&scoped=true"
import "./CarouselD.vue?vue&type=style&index=1&id=47970aee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47970aee"]])

export default __exports__